import { render, staticRenderFns } from "./text-with-icon.vue?vue&type=template&id=3e532054&scoped=true&"
import script from "./text-with-icon.vue?vue&type=script&lang=js&"
export * from "./text-with-icon.vue?vue&type=script&lang=js&"
import style0 from "./text-with-icon.vue?vue&type=style&index=0&id=3e532054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e532054",
  null
  
)

export default component.exports